var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArchive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.79895 14.1615H14.2297M19.7681 10.3954V16.1553C19.7681 17.3961 19.7684 18.0164 19.5269 18.4903C19.3145 18.9072 18.9752 19.2461 18.5583 19.4585C18.0844 19.6999 17.4645 19.7 16.2238 19.7H7.80533C6.5646 19.7 5.94378 19.6999 5.46988 19.4585C5.05303 19.2461 4.71437 18.9072 4.50197 18.4903C4.26051 18.0164 4.26051 17.3961 4.26051 16.1553V10.3954C4.26051 9.775 4.26051 9.46486 4.38124 9.22791C4.48744 9.01949 4.65677 8.85002 4.8652 8.74382C5.10214 8.62309 5.41202 8.62309 6.03238 8.62309H17.9954C18.6158 8.62309 18.9268 8.62309 19.1638 8.74382C19.3722 8.85002 19.5408 9.01949 19.647 9.22791C19.7677 9.46486 19.7681 9.775 19.7681 10.3954ZM19.7924 8.62309H4.23563C3.29345 8.62309 2.82287 8.6231 2.55571 8.45853C2.19949 8.23911 1.99752 7.83772 2.03324 7.42087C2.06002 7.10824 2.33997 6.72966 2.90078 5.97256C3.063 5.75357 3.1441 5.64407 3.24339 5.56045C3.37578 5.44896 3.53287 5.37005 3.70126 5.33004C3.82755 5.30003 3.9631 5.30003 4.23563 5.30003H19.7924C20.065 5.30003 20.2018 5.30003 20.3281 5.33004C20.4965 5.37005 20.6526 5.44896 20.785 5.56045C20.8843 5.64407 20.9657 5.75361 21.1279 5.97259C21.6887 6.72968 21.9691 7.10824 21.9959 7.42087C22.0316 7.83772 21.8297 8.23911 21.4735 8.45853C21.2063 8.6231 20.7346 8.62309 19.7924 8.62309Z",
    stroke: "#9C92E5",
    strokeWidth: 1.66153,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive);
export default __webpack_public_path__ + "static/media/archive.7bf4f29d70f075adef1fcfe9c5ea3524.svg";
export { ForwardRef as ReactComponent };